import React from 'react';
import { Info } from 'lucide-react';

interface ToolDescriptionProps {
  title: string;
  description: string;
  benefits: string[];
  howToUse: string;
}

const ToolDescription: React.FC<ToolDescriptionProps> = ({
  title,
  description,
  benefits,
  howToUse
}) => {
  return (
    <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-6 mb-6">
      <div className="flex items-center gap-2 mb-4">
        <Info size={20} className="text-blue-600 dark:text-blue-400" />
        <h2 className="text-xl font-semibold text-blue-800 dark:text-blue-200">About {title}</h2>
      </div>
      
      <div className="space-y-4">
        <div>
          <h3 className="font-medium text-gray-800 dark:text-gray-200 mb-2">What it does:</h3>
          <p className="text-gray-600 dark:text-gray-300">{description}</p>
        </div>

        <div>
          <h3 className="font-medium text-gray-800 dark:text-gray-200 mb-2">How to use:</h3>
          <p className="text-gray-600 dark:text-gray-300">{howToUse}</p>
        </div>

        <div>
          <h3 className="font-medium text-gray-800 dark:text-gray-200 mb-2">Benefits:</h3>
          <ul className="list-disc list-inside space-y-1 text-gray-600 dark:text-gray-300">
            {benefits.map((benefit, index) => (
              <li key={index}>{benefit}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ToolDescription;